/* ═══════════════════════════════════════════════════════════════
 * CHART — TradingView Lightweight Charts, thema = dubforvet-tokens
 * Bevat candlestick-serie + volume-histogram onderaan.
 * 1:1 poort van TERMINAL.chart uit terminal_wyckoffpcg.html,
 * maar tegen het echte lightweight-charts npm-pakket i.p.v. de
 * vendored/minified versie uit het losse HTML-bestand.
 * ═══════════════════════════════════════════════════════════════ */

import { createChart, CrosshairMode } from "lightweight-charts";
import { CONFIG as CFG } from "./config";

const C = CFG.colors;

export function createChartInstance(container) {
  const chart = createChart(container, {
    layout: {
      background: { type: "solid", color: "#0b0e11" },
      textColor: C.dim,
      fontFamily: "'JetBrains Mono','SF Mono',Menlo,monospace",
      fontSize: 11,
    },
    grid: {
      vertLines: { visible: false },
      horzLines: { visible: false },
    },
    crosshair: {
      mode: CrosshairMode.Normal,
      vertLine: { color: "rgba(139,149,161,0.35)", labelBackgroundColor: "#1f242c" },
      horzLine: { color: "rgba(139,149,161,0.35)", labelBackgroundColor: "#1f242c" },
    },
    rightPriceScale: {
      borderColor: "#1c2127",
      scaleMargins: { top: 0.08, bottom: 0.10 },
      entireTextOnly: true,
    },
    timeScale: {
      borderColor: "#1c2127",
      timeVisible: true,
      secondsVisible: false,
      rightOffset: 6,
      barSpacing: 7,
    },
    handleScroll: true,
    handleScale: true,
  });

  const candleSeries = chart.addCandlestickSeries({
    upColor: C.up, downColor: C.down,
    borderUpColor: C.up, borderDownColor: C.down,
    wickUpColor: C.up, wickDownColor: C.down,
    priceLineColor: C.accent,
    priceLineWidth: 1,
  });

  const volumeSeries = chart.addHistogramSeries({
    priceFormat: { type: "volume" },
    priceScaleId: "vol",
    color: "rgba(120,150,180,0.5)",
  });
  chart.priceScale("vol").applyOptions({
    scaleMargins: { top: 0.86, bottom: 0 },
  });

  const ro = new ResizeObserver((entries) => {
    if (!entries.length) return;
    const { width, height } = entries[0].contentRect;
    chart.resize(width, height);
  });
  ro.observe(container);

  return { chart, candleSeries, volumeSeries, _resizeObserver: ro };
}

export function setData(api, candles) {
  api.candleSeries.setData(candles);
  api.volumeSeries.setData(candles.map((c) => ({
    time: c.time,
    value: c.volume,
    color: c.close >= c.open ? "rgba(38,161,123,0.45)" : "rgba(224,69,91,0.45)",
  })));
}

export function updateCandle(api, c) {
  api.candleSeries.update({
    time: c.time, open: c.open, high: c.high, low: c.low, close: c.close,
  });
  api.volumeSeries.update({
    time: c.time, value: c.volume,
    color: c.close >= c.open ? "rgba(38,161,123,0.45)" : "rgba(224,69,91,0.45)",
  });
}

export function destroyChartInstance(api) {
  try { api._resizeObserver?.disconnect(); } catch {}
  try { api.chart.remove(); } catch {}
}
